import { InternalError } from '@/core/shared/errors/internal.error';
import { HttpStatus } from '@/core/shared/errors/enums/http-status.enum';
import { ProUnlockResultStatus } from '../types/pro-unlock-source.type';

// The daily-cap rejection (ONE-6862) arrives as FORBIDDEN with ERROR_LIMIT_REACHED in the
// payload. Every unlock surface should branch on this predicate rather than re-spelling
// the status checks.
export function isUnlockLimitError(error: unknown): boolean {
  return (
    error instanceof InternalError &&
    error.status === HttpStatus.FORBIDDEN &&
    error.data?.status === ProUnlockResultStatus.ERROR_LIMIT_REACHED
  );
}
